import { DialogHeader } from "@spz/ui/components/dialog";
import { useTranslation } from "react-i18next";
import { useWorkflowFormContext } from "./workflow-form-context";

export interface WorkflowDialogHeaderProps {
  className?: string;
}

export function WorkflowDialogHeader({ className }: WorkflowDialogHeaderProps) {
  const { t } = useTranslation();
  const formContext = useWorkflowFormContext();
  const count = formContext?.selectedCount || 1;

  return (
    <DialogHeader
      title={t(formContext?.schema?.action?.title_key || "", { count })}
      description={t(formContext?.schema?.action?.description_key || "", {
        count,
      })}
      className={className}
    />
  );
}
